import { useTranslation } from "react-i18next";

import { CHOICE_KEY, SUPPORTED_LANGUAGES } from "./i18n";

/**
 * The translator plus the active language: { t, currentLang, changeLanguage,
 * isEnglish, isFrench }. changeLanguage remembers the choice and ignores
 * unsupported codes.
 */
export default function useLocales() {
	const { t, i18n } = useTranslation();

	// resolvedLanguage is the locale actually in use after fallback, so a
	// detected 'fr-FR' reports as 'fr' rather than leaking the regional tag.
	const currentLang = i18n.resolvedLanguage || i18n.language;

	const changeLanguage = (newLang) => {
		if (!SUPPORTED_LANGUAGES.includes(newLang)) return;
		// A click is a choice: remember it (auto-detection never is).
		try {
			localStorage.setItem(CHOICE_KEY, newLang);
		} catch {}
		i18n.changeLanguage(newLang);
	};

	return {
		t,
		currentLang,
		changeLanguage,
		isEnglish: currentLang === "en",
		isFrench: currentLang === "fr",
	};
}
